import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
    Button,
    FormControl,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    TextField,
    Typography,
} from "@mui/material";

import AlertMessage from "../../components/AlertMessage/AlertMessage";

import Social from "./SocialLinks";
import "./Style.scss";

const defaultValue = { email: '' }

const ComingSoon = () => {
    const [formValues, setFormValues] = useState(defaultValue);
    const [message, setMessage] = useState<string>("");
    const [alert, setAlert] = useState<boolean>(false);

    const handleInputChange = (e: any) => {
        const { name, value }: any = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const requestBody = {
            source: 'portal',
            page: 'landing',
            data: {
                Email: `${formValues.email}`,
            },
        };
        axios
            .post(
                `${process.env.REACT_APP_API_BASE}/notify/v1/portalmessage`,
                requestBody,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json",
                    },
                }
            )
            .then(function (response) {
                setAlert(true);
                setMessage("success");
                setFormValues(defaultValue);
            })
            .catch(function (error) {
                setAlert(true);
                setMessage("fail");
            });
    }
    useEffect(() => {
        // when the component is mounted, the alert is displayed for 5 seconds
        setTimeout(() => {
            setAlert(false);
        }, 5000);
    }, []);

    return (
        <Grid className="coming-soon">
            {message === "success"
                ? AlertMessage(alert, "Message Send Succefully", "success")
                : message === "fail" &&
                AlertMessage(alert, "Message Send Failed", "error")}
            <Grid item className="coming-soon-head">
                <img
                    className="app-logo"
                    src={require("../../../src/Images/logo.png")}
                    alt="logo"
                />
            </Grid>
            <Grid item className="coming-soon-content">
                <img
                    className="coming_soon"
                    src={require("../../../src/Images/comingsoon.png")}
                    alt="coming-soon"
                />
                <form onSubmit={handleSubmit}>
                    <FormControl className="input-row">
                        <TextField value={formValues.email} onChange={handleInputChange} fullWidth type="email" name="email" required variant="outlined" placeholder="Enter Email Address" />
                    </FormControl>
                    <Button className="btn-rounded btn-notify" type="submit" variant="contained">
                        Notify Me
                    </Button>
                </form>
                <Grid className="connect-section">
                    <Typography className="connect-text">Connect with Us</Typography>
                    <List className="social-icons">
                        {Social.map((item: any) => (
                            <Link key={item.title} to={item.url}>
                                <ListItem className="list-item" key={item.title} disablePadding>
                                    <ListItemButton className="icon-btn">
                                        <ListItemIcon className="icon-svg">
                                            {item.icon}
                                        </ListItemIcon>
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                        ))}
                    </List>
                </Grid>
            </Grid>
            <footer>
                <p>
                    <a href="https://portal.managedsolution.com/privacy-policy" target="_blank" rel="noopener noreferrer"><b>Privacy Policy</b></a> | Copyright (c) 2022 Managed Solution LLC
                </p>
            </footer>
        </Grid>
    );
};

export default ComingSoon;
